import classNames from "classnames"
import * as React from "react"
import { Trans, useTranslation } from "react-i18next"

import { OverflowTooltip } from "@/components/design-system/OverflowTooltip/OverflowTooltip"

import "./Text.less"

type TextType =
  | "primary"
  | "secondary"
  | "placeholder"
  | "white"
  | "error"
  | "gray50"
  | "link"
  | "bluePurple100"
  | "inherit"

export interface TextProps extends React.HTMLProps<HTMLSpanElement> {
  children?: React.ReactNode
  className?: string
  type?: TextType
  truncated?: boolean

  // TODO: make required and explicitly check 'false' below
  strKey?: false | string
  i18n?: {
    values?: any
    components?: any[]
  }
}

export default function Text({
  className,
  type,
  truncated,
  strKey,
  i18n,
  children,
  style,
  ...restSpanProps
}: TextProps) {
  // Trans component does not use suspense well for ns,
  // so using the hook as well
  const { t, i18n: i18nLib } = useTranslation()

  const content = strKey ? <Trans t={t} i18nKey={strKey} {...i18n} /> : children

  const contentSpan = (
    <span
      className={classNames("Text", className, type || "primary", {
        truncated,
      })}
      style={
        // NOTE: We probably shouldn't be eating all the style value for
        // `truncated` behavior. However, this is a legacy behavior and needs
        // auditing before we can change it.
        truncated ? { display: "inline" } : style
      }
      {...restSpanProps}
      // NOTE: We override any external `dir` value here, which is probably not
      // desired. However, it's a legacy behavior and needs auditing before we
      // can change it.
      dir={i18nLib.dir()}
    >
      {content}
    </span>
  )

  return truncated ? (
    <OverflowTooltip title={content}>{contentSpan}</OverflowTooltip>
  ) : (
    contentSpan
  )
}
